import { IPagination } from "./api";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SyncIcon from '@mui/icons-material/Sync';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { IApprovalFlowExecution } from "./approvalFlowExecutions";

export const ApprovalStepStatusOptions = {
    pending: { label: "Pendente", color: "#FFC107", icon:HourglassEmptyIcon  }, // Amarelo
    inProgress: { label: "Em andamento", color: "#2196F3", icon:SyncIcon }, // Azul
    completed: { label: "Concluído", color: "#4CAF50", icon:CheckCircleIcon }, // Verde
    onHold: { label: "Em espera", color: "#FF9800", icon:PauseCircleFilledIcon }, // Laranja
    rejected: { label: "Rejeitado", color: "#F44336", icon:CancelIcon }, // Vermelho
    canceled: { label: "Cancelado", color: "#9E9E9E", icon:CancelIcon }, // Cinza
    failed: { label: "Falhou", color: "#E53935", icon:ErrorIcon }, // Vermelho escuro
    delayed: { label: "Atrasado", color: "#FF5722", icon:WarningIcon }, // Laranja avermelhado
    underReview: { label: "Em revisão", color: "#03A9F4", icon:VisibilityIcon }, // Azul claro
    approved: { label: "Aprovado", color: "#4CAF50", icon:DoneAllIcon }, // Verde
    needsReview: { label: "Precisa de revisão", color: "#FFEB3B", icon:AssignmentTurnedInIcon }, // Amarelo claro
    finalized: { label: "Finalizado", color: "#8BC34A", icon:CheckCircleIcon }, // Verde médio
    waiting: { label: "Aguardando", color: "#607D8B", icon:HourglassBottomIcon } // Azul acinzentado
};


export enum EApprovalStepStatus {
    Pending = "pending",
    InProgress = "inProgress",
    Completed = "completed",
    OnHold = "onHold",
    Rejected = "rejected",
    Canceled = "canceled",
    Failed = "failed",
    Delayed = "delayed",
    UnderReview = "underReview",
    Approved = "approved",
    NeedsReview = "needsReview",
    Finalized = "finalized",
    Waiting = "waiting"
}


export interface IResponseListApprovalFlowExecutionSteps extends IPagination {
    approvalFlowExecutionSteps: IApprovalFlowExecutionStep[]
}

export interface IResponseShowApprovalFlowExecutionStep {
    approvalFlowExecutionStep: IApprovalFlowExecutionStep
}

export interface IApprovalFlowExecutionStep {
    id: number;
    isFinal: boolean;
    idStep: number;
    status: EApprovalStepStatus;
    idApprovalFlow: number;
    approvalFlowExecution?: IApprovalFlowExecution;
    idApprovalFlowExecution: number;
    name: string;
    isInitialStep?: boolean;
    description?: string;
    idGroupAssigned?: number;
    idUserAssigned?: number;
    responseTime?: number;
    startedAt?: Date;
    finishedAt?: Date;
    slaDeadline?: Date;
    createdIn: Date;
    updatedIn?: Date;
    updatedBy?: number;
    createdBy?: number;
    idStepExecution?: number
    interaction?: { body?: '' }
}
